import { BaseComponent } from './base-component.js';
import { customElement, property } from 'lit/decorators.js';
import { html, css, CSSResultGroup, TemplateResult, nothing } from 'lit';

@customElement('il-divider')
export default class DividerComponent extends BaseComponent {
  @property({ type: String }) label?: string
  @property({ type: String }) labelPosition: 'center' | 'left' | 'right' = 'center'

  labelElement(): TemplateResult {
    if (this.label) {
      return html`<span data-testid='iliad-divider-label' class="il-divider__label">${this.label}</span>`
    }

    return html``
  }

  dividerElement(): TemplateResult {
    return html`<hr data-testid='iliad-divider' class="il-divider" />`
  }

  override render(): TemplateResult {
    return html`
      <div class="il-divider__container">
        ${this.labelPosition !== 'left' && this.label ? this.dividerElement() : nothing}
        ${this.labelElement()}
        ${this.labelPosition !== 'right' ? this.dividerElement() : nothing}
      </div>
    `
  }

  static override styles: CSSResultGroup = [
    BaseComponent.styles,
    css`
      :host {
        width: 100%;
      }

      .il-divider__container {
        display: flex;
        align-items: center;
        gap: 16px;
        max-height: 10px;
      }

      .il-divider {
        border: none;
        margin: 0;
        border-bottom: 1px solid var(--il-color-neutrals-100);
        width: 100%;
      }

      .il-divider__label {
        color: var(--il-color-neutrals-300);
        font-size: var(--il-font-size-14);
        font-weight: var(--il-font-weight-xbold);
        line-height: var(--il-font-line-height-150);
        letter-spacing: var(--il-font-letter-spacing-2);
      }
    `,
  ]
}

declare global {
  interface HTMLElementTagNameMap {
    'il-divider': DividerComponent
  }
}
